
    import { Component, Vue } from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase';

    interface StoreInfo {
        id: number;
        storeName: string;
    }

    interface ProductInfo {
        productId: number;
        stockOrderProductId: number;
        stockOrderId: number;
        productName: string;
        productSku: string;
        productImgGuid: string;
        productLink: string;
        count: number;
        shelfPosition: string;
        productNo: string;
    }

    interface OperationRecord {
        orderNumber: string;
        time: Date;
        success: boolean;
    }

    interface Statistics {
        total: number;
        success: number;
        failure: number;
        processedOrders: Set<string>;
    }

    @Component({
        name: "packconfirm"
    })
    export default class OutboundConfirm extends AbpBase {
        // 表单数据
        formData = {
            storeIds: [] as number[],
            orderNumber: '',
            productLabel: ''
        };

        // 仓库列表
        storeList: StoreInfo[] = [];

        // 当前订单信息
        currentOrder = {
            orderNumber: '',
            productInfos: [] as ProductInfo[]
        };

        // 扫描记录，用于存储每个商品的已扫描数量
        scanRecords: Map<number, number> = new Map();

        // 最近操作记录
        recentOperations: OperationRecord[] = [];

    get canConfirmPack(): boolean {
    return this.currentOrder.orderNumber !== '' && this.checkAllProductsScanned();
}
        // 自动确认
        autoConfirm = false;

        // 加载状态
        loading = false;

        // 扫描提示信息
        scanMessage = '';
        scanMessageType: 'success' | 'error' | 'info' = 'info';

        // 统计信息
        statistics: Statistics = {
            total: 0,
            success: 0,
            failure: 0,
            processedOrders: new Set<string>()
        };

        // 计算商品列表（添加已扫描数量）
        get productList() {
            return this.currentOrder.productInfos.map(product => {
                const scannedCount = this.scanRecords.get(product.productId) || 0;
                return {
                    ...product,
                    scannedCount: scannedCount
                };
            });
        }

        playAudio(audioId: string) {
            try {
                const audio = document.getElementById(audioId) as HTMLAudioElement;
                if (audio) {
                    audio.currentTime = 0; // 重置到开始
                    audio.play().catch(error => {
                        console.error('音频播放失败:', error);
                    });
                }
            } catch (error) {
                console.error('播放音频时出错:', error);
            }
        }

        // 格式化时间为 HH:mm:ss
        formatTimeToHHMMSS(time: Date): string {
            if (!time) return '';
            const date = new Date(time);
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');
            return `${hours}:${minutes}:${seconds}`;
        }

        // 跳转首页
        goToHome() {
            this.$router.push('/backhome');
        }

        // 仓库选择变化
        onStoreChange(value: number[]) {
            // 可以留空或添加必要的逻辑
        }

        // 运单号回车事件
        async handleOrderNumberEnter() {
            if (!this.formData.storeIds || this.formData.storeIds.length === 0) {
                this.showScanMessage('请先选择仓库', 'error');
                return;
            }

            const orderNumber = this.formData.orderNumber.trim();
            if (!orderNumber) {
                this.showScanMessage('请输入运单号', 'error');
                return;
            }

            this.loading = true;
            
            try {
                const storeIdsString = this.formData.storeIds.join(',');
                
                const response = await this.$store.dispatch({
                    type: 'backstockorder/getOrderByTradeNo',
                    data: {
                        storeId: storeIdsString,
                        orderNumber: orderNumber
                    }
                });

                if (response.data.success && response.data.result) {
                    const orderData = response.data.result;
                    
                    this.scanRecords.clear();
                    
                    this.currentOrder.orderNumber = orderData.orderNumber || orderNumber;
                    
                    if (orderData.productInfos && Array.isArray(orderData.productInfos)) {
                        this.currentOrder.productInfos = orderData.productInfos.map((item: any) => {
                            this.scanRecords.set(item.productId || 0, 0);
                            
                            return {
                                productId: item.productId || 0,
                                stockOrderProductId: item.stockOrderProductId || 0,
                                stockOrderId: item.stockOrderId || 0,
                                productName: item.productName || '',
                                productSku: item.productSku || '',
                                productImgGuid: item.productImgGuid || '',
                                productLink: item.productLink || '',
                                count: item.count || 0,
                                shelfPosition: item.shelfPosition || '',
                                productNo: item.productNo || ''
                            };
                        });
                    } else {
                        this.currentOrder.productInfos = [];
                    }

                    this.showScanMessage(`已加载订单 ${this.currentOrder.orderNumber}，共 ${this.currentOrder.productInfos.length} 种商品`, 'success');
                    // 播放订单成功音效
                    this.playAudio('orderSuccessAudio');

                    this.$nextTick(() => {
                        const productInput = this.$refs.productLabelInput as HTMLInputElement;
                        if (productInput) {
                            productInput.focus();
                        }
                    });
                } else {
                    this.showScanMessage('未找到该订单信息', 'error');
                }
            } catch (error: any) {
                this.showScanMessage('查询订单失败: ' + (error.message || '未知错误'), 'error');
                this.playAudio('errorAudio');
            } finally {
                this.loading = false;
            }
        }

        // 商品标签回车事件
        handleProductLabelEnter() {
            const productLabel = this.formData.productLabel.trim();
            if (!productLabel) {
                this.showScanMessage('请输入商品标签', 'error');
                return;
            }

            const product = this.currentOrder.productInfos.find(
                p => p.productNo === productLabel
            );

    if (!product) {
        this.$Modal.error({
            title: '商品不存在',
            content: `商品 ${productLabel} 不在当前订单中！`,
            onOk: () => {
                this.formData.productLabel = '';
                this.$nextTick(() => {
                    const productInput = this.$refs.productLabelInput as HTMLInputElement;
                    if (productInput) {
                        productInput.focus();
                    }
                });
            }
        });
        return; 
    }

            const currentScanned = this.scanRecords.get(product.productId) || 0;
            
    if (currentScanned >= product.count) {
        this.$Modal.error({
            title: '超过数量',
            content: `商品 ${product.productId} 数量为 ${product.count}，已扫描 ${currentScanned} 个！`,
            onOk: () => {
                this.formData.productLabel = '';
                this.$nextTick(() => {
                    const productInput = this.$refs.productLabelInput as HTMLInputElement;
                    if (productInput) {
                        productInput.focus();
                    }
                });
            }
        });
        return; 
    }  

            this.scanRecords.set(product.productId, currentScanned + 1);
            this.currentOrder.productInfos = [...this.currentOrder.productInfos];
            
            const newScanned = currentScanned + 1;
            const remaining = product.count - newScanned;
            
            this.showScanMessage(`已扫描商品: ${product.productName} (${newScanned}/${product.count})，剩余${remaining}个`, 'success');
            this.formData.productLabel = '';

            if (this.checkAllProductsScanned()) {
                this.showScanMessage('所有商品已扫描完成，可以确认打包', 'success');
                if (this.autoConfirm) {
                    setTimeout(() => {
                        this.confirmOutbound();
                    }, 1500);
                }
            }

            this.$nextTick(() => {
                const productInput = this.$refs.productLabelInput as HTMLInputElement;
                if (productInput) {
                    productInput.focus();
                }
            });
        }

        // 检查所有商品是否已扫描完成
        checkAllProductsScanned(): boolean {
            if (this.currentOrder.productInfos.length === 0) {
                return false;
            }
            
            return this.currentOrder.productInfos.every(product => {
                const scannedCount = this.scanRecords.get(product.productId) || 0;
                return scannedCount >= product.count;
            });
        }

        // 确认打包
        async confirmOutbound() {
            if (!this.currentOrder.orderNumber) {
                this.showScanMessage('请先查询订单', 'error');
                return;
            }

            if (!this.checkAllProductsScanned()) {
                this.showScanMessage('请先扫描完所有商品', 'error');
                return;
            }

            this.loading = true;
            
            try {
                const orderNumber = this.formData.orderNumber.trim();
                const storeIdsString = this.formData.storeIds.join(',');
                
                await this.$store.dispatch({
                    type: 'backstockorder/confirmArriveOrder',
                    data: {
                        storeId: storeIdsString,
                        orderNumber: orderNumber
                    }
                });

                // 添加操作记录
                const record: OperationRecord = {
                    orderNumber: this.currentOrder.orderNumber,
                    time: new Date(),
                    success: true
                };
                this.recentOperations.unshift(record);
                if (this.recentOperations.length > 10) {
                    this.recentOperations.pop();
                }

                this.showScanMessage(`订单 ${this.currentOrder.orderNumber} 打包成功`, 'success');
                this.playAudio('outboundSuccessAudio');

                this.updateStatistics(this.currentOrder.orderNumber, true);
                
                this.resetOrder();
                
                this.$nextTick(() => {
                    const orderInput = this.$refs.orderNumberInput as HTMLInputElement;
                    if (orderInput) {
                        orderInput.focus();
                    }
                });
            } catch (error: any) {
                // 添加失败记录
                const record: OperationRecord = {
                    orderNumber: this.currentOrder.orderNumber,
                    time: new Date(),
                    success: false
                };
                this.recentOperations.unshift(record);
                if (this.recentOperations.length > 10) {
                    this.recentOperations.pop();
                }

                let errorMessage = '打包失败';
                if (error.message) {
                    errorMessage = error.message;
                }
                this.showScanMessage(errorMessage, 'error');

                this.playAudio('errorAudio');
                this.updateStatistics(this.currentOrder.orderNumber, false);
            } finally {
                this.loading = false;
            }
        }

        // 重置订单
        resetOrder() {
            this.currentOrder = {
                orderNumber: '',
                productInfos: []
            };
            this.scanRecords.clear();
            this.formData.orderNumber = '';
            this.formData.productLabel = '';
            this.scanMessage = '';
            
            this.$nextTick(() => {
                const orderInput = this.$refs.orderNumberInput as HTMLInputElement;
                if (orderInput) {
                    orderInput.focus();
                }
            });
        }

        // 重置商品
        resetProduct() {
            this.scanRecords.clear();
            this.formData.productLabel = '';
            this.scanMessage = '';
            
            if (this.currentOrder.productInfos.length > 0) {
                this.currentOrder.productInfos = [...this.currentOrder.productInfos];
            }
            
            this.$nextTick(() => {
                const productInput = this.$refs.productLabelInput as HTMLInputElement;
                if (productInput) {
                    productInput.focus();
                }
            });
        }

        // 重置统计
        resetStatistics() {
            this.$Modal.confirm({
                title: '确认重置统计',
                content: '确定要重置统计信息吗？',
                onOk: () => {
                    this.statistics = {
                        total: 0,
                        success: 0,
                        failure: 0,
                        processedOrders: new Set<string>()
                    };
                    this.saveStatistics();
                }
            });
        }

        // 显示扫描提示信息
        showScanMessage(message: string, type: 'success' | 'error' | 'info' = 'info') {
            this.scanMessage = message;
            this.scanMessageType = type;
            
            setTimeout(() => {
                this.scanMessage = '';
            }, 3000);
        }

        // 更新统计信息
        updateStatistics(orderNumber: string, success: boolean) {
            if (this.statistics.processedOrders.has(orderNumber)) {
                return false;
            }

            this.statistics.processedOrders.add(orderNumber);
            this.statistics.total++;
            if (success) {
                this.statistics.success++;
            } else {
                this.statistics.failure++;
            }

            this.saveStatistics();
            return true;
        }

        // 保存统计信息
        saveStatistics() {
            try {
                const statsToSave = {
                    total: this.statistics.total,
                    success: this.statistics.success,
                    failure: this.statistics.failure,
                    processedOrders: Array.from(this.statistics.processedOrders)
                };
                localStorage.setItem('outbound_statistics', JSON.stringify(statsToSave));
            } catch (error) {
                // 静默失败
            }
        }

        // 加载仓库列表
        async loadStoreList() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            });

            this.storeList = this.$store.state.backstoreaddress.list.filter(function (item) {
                return item.whetherEffective == true
            });

            if (this.storeList.length == 1) {
                this.formData.storeIds = [this.storeList[0].id];
            } else {
                this.formData.storeIds = [];
            }
        }

        // 加载统计信息
        loadStatistics() {
            try {
                const savedStats = localStorage.getItem('outbound_statistics');
                if (savedStats) {
                    const stats = JSON.parse(savedStats);
                    this.statistics.total = stats.total || 0;
                    this.statistics.success = stats.success || 0;
                    this.statistics.failure = stats.failure || 0;
                    this.statistics.processedOrders = new Set(stats.processedOrders || []);
                }
            } catch (error) {
                // 静默失败
            }
        }

        // 组件创建时
        async created() {
            this.loadStatistics();
            await this.loadStoreList();
            
            this.$nextTick(() => {
                const input = this.$refs.orderNumberInput as HTMLInputElement;
                if (input) {
                    input.focus();
                }
            });
        }
    }
